/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'bot-mapping';
const prefix = `${moduleName}.${componentName}`;

export const botMappingBreadcrumbTitle = `${prefix}.botMappingBreadcrumbTitle`;

export const ENGLISH = {
    [botMappingBreadcrumbTitle]: 'Bot Mapping',
};
